import React from 'react'
import { motion } from 'framer-motion'
import { Section } from './ui'
import { ACTIVITIES } from '../constants'
import { cn } from '../utils'

const WhatWeDoSection: React.FC = () => {
  return (
    <Section id="what-we-do" background="muted" padding="xl">
      <Section.Header
        subtitle="What We Do"
        title="A think tank with the discipline of a delivery lab."
        description="MATNO combines the rigor of a think tank with the practicality of an implementation lab."
        align="center"
      />

      <div className="max-w-4xl mx-auto">
        <ol className="relative">
          {ACTIVITIES.map((activity, index) => (
            <motion.li
              key={activity.key}
              initial={{ opacity: 0, y: 16 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: '-40px' }}
              transition={{ duration: 0.45, delay: index * 0.06 }}
              className={cn(
                'group relative flex gap-5 md:gap-8 py-6 md:py-7',
                index !== 0 && 'border-t border-gray-200 dark:border-gray-800'
              )}
            >
              {/* Numeric marker */}
              <div className="flex-shrink-0 pt-1">
                <div
                  className={cn(
                    'w-10 h-10 md:w-11 md:h-11 rounded-lg flex items-center justify-center',
                    'text-sm font-semibold tabular-nums',
                    'bg-white dark:bg-gray-900',
                    'border border-gray-200 dark:border-gray-800',
                    'text-secondary-500 dark:text-secondary-300',
                    'transition-colors duration-200',
                    'group-hover:border-primary-400 group-hover:text-primary-500 dark:group-hover:text-primary-300'
                  )}
                  aria-hidden="true"
                >
                  {String(index + 1).padStart(2, '0')}
                </div>
              </div>

              <div className="flex-1 min-w-0">
                <h3 className="text-xl md:text-2xl font-semibold text-gray-900 dark:text-white mb-2 tracking-tight">
                  {activity.title}
                </h3>
                <p className="text-base text-gray-600 dark:text-gray-300 leading-relaxed max-w-2xl">
                  {activity.description}
                </p>
              </div>
            </motion.li>
          ))}
        </ol>
      </div>
    </Section>
  )
}

export default WhatWeDoSection
